// extracted by mini-css-extract-plugin
export default {"root":"DurationRow-root_V1aSR","hasBetterOffer":"DurationRow-hasBetterOffer_o6hXh"};